<template>
    <section class="single-travelogue-content">
        <div class="wrapper">

            <div class="row">
                <div class="col-lg-3 d-none d-lg-block  week-nav-col">
                    <nav class="week-nav" v-if="allweeks.length > 1">
                        <div class="bar"></div>
                        <div v-for="(week, index) in allweeks"
                             class="week-link"
                             :class="week.slug"
                             @click="scrollToWeekContent(index)"
                        >
                            <span class="label" v-if="limitLabel(index)" v-html="showLabel(index)"></span>
                            <span>Semaine {{index+1 | formatedDay}}</span>
                        </div>
                    </nav>
                </div>
                <div class="col-lg-6 d-lg-none filter-mobile" v-if="allweeks.length > 1">
                    <p>Journal de bord</p>
                    <custom-select
                            valueField="index"
                            labelField="week_name"
                            v-model="positionStatus"
                            :options="allweeks"
                            v-on:change="scrollToWeekContent($event)"
                    ></custom-select>
                </div>
                <div class="col-lg-8 col-xl-6 content-wrapper rte">

                    <transition-group name="list" tag="div">
                        <article v-for="(week, index) in allweeks"
                                 class="one-week"
                                 :key="index"
                                 v-if="showWeek(index)"
                                 :class=week.slug
                        >

                            <slot :name="week.slug"></slot>

                        </article>
                    </transition-group>

                    <a href="" class="btn outline chevron dir-down loadmore"
                       @click.prevent="showMore()"
                       v-if="!reachEnd"
                    >Voir la suite de la croisière</a>
                    <a v-if="reachEnd"></a>

                </div>
            </div>


        </div>
    </section>
</template>

<script>
    import $ from 'jquery';
    import ScrollMagic from 'scrollmagic';
    import ScrollMagicGE from '../../libs/ScrollMagicGE';
    import Scrolling from '../../libs/Scrolling'
    import {debounce} from 'lodash';
    import {breakpointDown} from '../../libs/Breakpoints';

    export default {
        props: {
            allweeks: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                controller: new ScrollMagic.Controller(),
                weekShowLimit: 1,
                positionStatus: 0,
                barTransitionDuration: 0,

            };
        },
        computed: {
            reachEnd() {
                return this.allweeks.length <= this.weekShowLimit
            }
        },
        methods: {
            limitLabel(index) {
                return index === 0 || index === this.allweeks.length - 1
            },
            showLabel(index) {
                return index === 0 ? 'Départ' : 'Fin'
            },
            showWeek(index) {
                return index < this.weekShowLimit
            },
            showMore(index) {
                let lastIndex = this.weekShowLimit - 1

                this.weekShowLimit = index ? this.weekShowLimit = index + 1 : this.weekShowLimit + 1

                setTimeout(() => {
                    $('article.one-week').length > 1 ? ScrollMagicGE.weekNav() : null

                    for (var i = lastIndex + 1; i < this.weekShowLimit; i++) {

                        this.createScene(i)
                    }


                }, 100)


            },
            weekPagination: debounce(function () {

                this.barTransitionDuration = parseFloat($('.week-nav .bar').css('transition-duration')) * 1000

                for (var i = 0; i < this.weekShowLimit; i++) {
                    this.createScene(i)
                }
                this.updateWeekNavStyle()

            }, 1000),
            createScene(index) {

                let duration = $('.content-wrapper .week_' + index).innerHeight()

                new ScrollMagic.Scene({
                    triggerElement: '.content-wrapper .week_' + index,
                    triggerHook: 0.5,
                    duration: duration,
                    offset: 0,
                })
                    .addTo(this.controller)
                    // .addIndicators() // add indicators (requires plugin)
                    .on("progress", (e) => {

                        this.positionStatus = index
                        this.updateWeekNavStyle(e.scrollDirection)

                    });
                ;

            },
            updateWeekNavStyle: debounce(function (direction) {
                $('.week-nav .bar').height(this.positionStatus * 75)

                let duration = direction === 'FORWARD' ? duration = this.barTransitionDuration : 10

                setTimeout(() => {
                    $('.week-nav .week-link').removeClass('active')
                    for (var i = 0; i <= this.positionStatus; i++) {
                        $('.week-nav .week_' + i).addClass('active')
                    }
                }, duration)

            }, 100),
            scrollToWeekContent(index) {
                let duration = 0
                if (index >= this.weekShowLimit) {
                    this.showMore(index)
                    duration = 200
                }
                setTimeout(function () {
                    let offset = breakpointDown('md') ? 0 : 150
                    Scrolling.scrollTo('.content-wrapper .week_' + index, 'easeOutQuint', 1000, offset)
                }, duration)

            }


        },
        mounted() {
            setTimeout(function () {
                $('article.one-week').length > 1 ? ScrollMagicGE.weekNav() : null
            }, 1000)
            this.weekPagination()


        },
    }
</script>




// WEBPACK FOOTER //
// assets/js/components/magazine/SingleTravelogueContent.vue